export default function AnalyteLimitInfo({ limit, selectedCount }) {
  if (limit === null || limit === undefined) {
    return null;
  }

  return (
    <h6>
      Заказанное количество аналитов: <b>{limit}</b>,{' '}
      <span className={selectedCount > limit ? 'text-danger' : undefined}>
        выбрано: <b>{selectedCount}</b>
      </span>
    </h6>
  );
}
